export default function ProductPrice({ active, children }: { active: boolean, children: JSX.Element | string }) {
    const className = active ? 'text-white' : 'text-muted';
    return <div className={className}>{children}</div>;
}